import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export type RegisteredCompany = {
  id: string;
  name: string;
};

export function useRegisteredCompanies(): {
  data?: RegisteredCompany[];
  error?: unknown;
  mutate: KeyedMutator<RegisteredCompany[]>;
} {
  const { data, error, mutate } = useSWR<RegisteredCompany[]>(
    'mailroom/admin/dra-companies',
    SWRFetcher({
      method: 'GET',
    })
  );

  return { data, error, mutate };
}
